export interface Charge {
    id: number;
    newcharges: { [key: string]: string | number };
}

export interface Merchant {
    id: number;
    name: string;
    url: string;
    dba: string;
    caprate: number;
    capacity: number;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    ein: number;
    mpa: string;
    persona: string;
    status: string;
    email: string;
    startDate: string;
    mpaStartDate: string;
    merchantCode: string;
    terminationDate: string | null;
    bankDetails?: BankInfoResponse[];
    totaldata: TotalDataItem[];
    charges?: Charge[];
    stats?: Stats;
    createdAt: string;
    updatedAt: string;
}
export interface TotalDataItem {
    achAmount: string;
    chargebackFee: string;
    icAmount: string;
    payoutserviceCharge: string;
    refundAmount: string;
    refundFee: string;
    reserveFee: string;
    sstgFee: string;
    transactionAmount: string;
}

export interface Stats {
    transactionstats: TransactionStats[]; // nested array inside stats
}

export interface TransactionStats {
    week_start: string;
    total_transactions: string;
    total_chargeback: string;
}

export interface MerchantResponse {
    merchants: Merchant[];
}
export interface SingleMerchantResponse {
    data: Merchant;
    message: string;
    success: boolean;
}

export interface TableColumn {
    id: string;
    label: string;
    minWidth?: number;
    align?: 'right' | 'left' | 'center';
    format?: (value: any) => string;
}

export interface ApiResponse<T> {
    data: T;
    message: string;
    success: boolean;
}

export interface EnvironmentConfig {
    API_BASE_URL: string;
    ENVIRONMENT: string;
    APP_NAME: string;
    VERSION: string;
}

export interface CreateMerchantRequest {
    name: string;
    url: string;
    dba: string;
    caprate: number | null;
    capacity: number | null;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    ein: number | null;
    mpa: string;
    persona: string;
    status: string;
    email: string;
    startDate: string;
    mpaStartDate: string;
    merchantCode: string;
}

export enum MerchantStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export interface CreateChargeRequest {
    name: string;
    value: number | null;
    status: string;
    chargeCode: string;
}

// Calculation Request/Response Types
export interface ReserveCalculationRequest {
    reserveRate: number;
    grossSales: number;
}

export interface ReserveCalculationResponse {
    reservefee: number;
}

export interface ICCalculationRequest {
    icRate: number;
    grossSales: number;
}

export interface ICCalculationResponse {
    interchange: number;
}

export interface SSTGCalculationRequest {
    sstgRate: number;
    grossSales: number;
}

export interface SSTGCalculationResponse {
    sstgfee: number;
}

export interface TransactionCalculationRequest {
    transactionRate: number;
    transactionCount: number;
}

export interface TransactionCalculationResponse {
    transactionfee: number;
}

export interface RefundCalculationRequest {
    refundCount: number;
    refundAmount: number;
    refundfee: number;
}

export interface RefundCalculationResponse {
    totalrefund: number;
}

export interface ChargebackCalculationRequest {
    chargebackCount: number;
    chargebackAmount: number;
    chargebackFee: number;
}

export interface ChargebackCalculationResponse {
    chargebackfee: number;
}

export interface WireFeeCalculationRequest {
    wireCount: number;
    wireAmount: number;
}

export interface AchFeeCalculationRequest {
    achCount: number;
    achAmount: number;
}

export interface WireFeeCalculationResponse {
    wirefeeamount: number;
}

export interface AchFeeCalculationResponse {
    achfeeamount: number;
}

export interface totalcostCalculationRequest {
    chargebackamount: number;
    chargebackcost: number;
    iccost: number;
    reservecost: number;
    sstgcost: number;
    transactioncost: number;
    refundcost: number;
    refundamount: number;
    payoutservicecharge: number;
    achfeeamount: number;
}

export interface totalcostCalculationResponse {
    totaltransactioncost: number;
}

export interface NetPayoutCalculationRequest {
    totalcost: number;
    grosssales: number;
}

export interface NetPayoutCalculationResponse {
    netpayout: number;
}
export interface CreateBankInfoRequest {
    name: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zipcode: number;
    accountNumber: number;
    accountType: string;
    routingNumber: number;
    transmissionType: string;
    merchantId: number;
    wires: number;
}

export interface BankInfoResponse {
    id: number;
    name: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zipcode: number;
    accountNumber: string;
    accountType: string;
    routingNumber: string;
    transmissionType: string;
    merchantId: number;
    wires: number;
    countryCode?: string;
    ibanNumber?: string;
    swiftCode?: string;
    status?: string;
    updatedAt?: string;
    createdAt: string;
}
export interface SaveMerchantTransactionRequest {
    day: string;
    date: string;
    sales: number;
    chargebackCount: number;
    chargebackFee: number;
    chargebackAmount: number;
    chargebackFeeAmount: number;
    icRate: number;
    icAmount: number;
    refundCount: number;
    refundFee: number;
    refundFeeAmount: number;
    refundAmount: number;
    sstgCharge: number;
    sstgFee: number;
    reserveCharge: number;
    reserveFee: number;
    wirecount: number;
    payoutServiceCharge: number;
    totalCost: number;
    paid_amount: number;
    netPayout: number;
    transactions: number;
    transactionCharge: number;
    transactionFee: number;
    merchantId?: number; // Made optional with ?
    achAmount: number;
    transferType: string;
    achcount: number;
    wireAmount: number;
}

export interface SaveMerchantTransactionResponse {
    success: boolean;
    message?: string;
    data?: any;
    error?: any;
}

export interface DeleteChargeResponse {
    msg: string;
    data: {
        generatedMaps: any[];
        raw: any[];
        affected: number;
    };
}
export interface DeleteMerchantResponse {
    msg: string;
    result: {
        generatedMaps: any[];
        raw: any[];
        affected: number;
    };
}
export interface DeleteTransactionResponse {
    msg: string;
}
export interface GetMerchantTransactionsRequest {
    merchantId: number;
    startDate: string;
    endDate: string;
}

export interface MerchantTransaction {
    id: number;
    day: string;
    date: string;
    sales: string;
    chargebackCount: number;
    chargebackFee: string;
    chargebackAmount: string;
    chargebackFeeAmount: string;
    icRate: string;
    icAmount: string;
    refundCount: number;
    refundFee: string;
    refundFeeAmount: string;
    refundAmount: string;
    sstgCharge: string;
    sstgFee: string;
    reserveCharge: string;
    reserveFee: string;
    transferType: string;
    wirecount: number;
    achcount: number;
    achAmount: number;
    payoutServiceCharge: string;
    totalCost: string;
    paid_amount: number;
    netPayout: string;
    transactions: number;
    transactionCharge: string;
    transactionFee: string;
    payout1Amount: number | null;
    payout2Amount: number | null;
    merchantId: number;
}

export interface ChargeById {
    id?: number;
    name: string;
    value: number;
    status: 'active' | 'inactive';
    chargeCode: string;
    merchantId?: number;
    createdAt?: string;
    updatedAt?: string;
}
export interface TransactionData {
    name: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zipcode: string | number;
    accountNumber: string | number;
    accountType: string;
    routingNumber: string | number;
    transmissionType: string;
    merchantId: string;
    wires: string | number;
    countryCode: string;
    ibanNumber: string | number;
    swiftCode: string;
}

export interface ChargeByIdResponse {
    data: ChargeById;
}
export interface TransactionByIdResponse {
    data: TransactionData;
}

export interface StateByCountryCode {
    states: State[];
}
export interface State {
    countryId: number;
    id: number;
    name: string;
    stateCode: string;
    status: string;
}

export interface ChargeCodeItem {
    id: number;
    name: string;
    code: string;
}

export interface ChargeCodeResponse {
    data: ChargeCodeItem[];
}
